import {
  type Board,
  type Table,
  type TableColumns,
  TableRow,
  type TableRowColumn,
  type TableRowComment,
} from 'src/generated/graphql';
import type { BoardAutomationType } from 'src/sections/@dashboard/board/BoardAutomationDialog/types';
import { addListener } from '../common';

export const onBoardCreated = addListener<Board>('/board/new');
export const onBoardUpdated = addListener<Board>('/board/update');
export const onTableCreated = addListener<Table>('/board/table/new');
export const onTableRowsRefetch = addListener<Board>(
  '/board/table/row/refetch',
);
export const onTableAutomationRunning = addListener<BoardAutomationType>(
  '/board/table/automation/running',
);
export const onTableRowCreated = addListener<TableRow>('/board/table/row/new');
export const onTableRowUpdated = addListener<TableRow & { updatedBy: string }>(
  '/board/table/row/update',
);
export const onTableRowBulkUpdate = addListener<{
  tableId: string;
  rowIds: string;
  columns: Record<string, TableRowColumn>;
}>('/board/table/row/bulk-update');
export const onTableRowDeleted = addListener<{
  tableId: string;
  rowIds: string[];
}>('/board/table/row/delete');
export const onTableRowComment =
  addListener<TableRowComment>('/board/message/new');

export const onTableColumnCreated = addListener<TableColumns>(
  '/board/table/columns/new',
);
